import * as types from './entryQualificationSubject.types'

const initialState = {
	isLoading: false,
	isSuccess: false,
	entryQualificationSubject: {
		subject_identifier_id: null,
	},
	options: {},
	permissions: {},
}

export const reducer = (state = initialState, action) => {
	const { type, payload } = action
	switch (type) {
		case types.TOGGLE_LOADING:
			return {
				...state,
				isLoading: payload,
			}
		case types.SET_ENTRY_QUALIFICATION_SUBJECT:
			return {
				...state,
				entryQualificationSubject: payload,
			}
		case types.TOGGLE_SUCCESS:
			return {
				...state,
				isSuccess: payload,
			}
		case types.SET_OPTIONS:
			return {
				...state,
				options: payload,
			}
		case types.CLEAR_DATA:
			return {
				...state,
				entryQualificationSubject: initialState.entryQualificationSubject,
			}
		case types.SET_PERMISSIONS:
			return {
				...state,
				permissions: payload,
			}
		default:
			return state
	}
}
